import { FC, CSSProperties, useMemo } from "react";
// 组件
import { InfoCircleOutlined } from "@ant-design/icons";
import { ProTooltip } from '../../../antd';
import CopyText from '../../../CopyText';
// 方法
import classNames from "classnames";
import { useLayoutContext } from '../../../PageLayout/context/LayoutContext';
import { filterEmptyValue } from "../../../utils/utils";
import { renderEnumName } from "../../../utils/renderUtils";
// 常量
import { ScanPageRightRowItemProps, ScanPageRightItemEnum, } from "../../interface";
/** 自定义右侧内容 */
const RowItem: FC<ScanPageRightRowItemProps> = props => {
  const { className, style, options, labelWidth, title, tooltipIcon, tooltipText, } = props;
  const { enumData } = useLayoutContext();
  const classes = classNames('body-right-row-wrapper', className);
  const labelStyle: CSSProperties | undefined = useMemo(() => {
    if (labelWidth) return { width: labelWidth };
  }, [ labelWidth ]);
  const textStyle: CSSProperties | undefined = useMemo(() => {
    if (labelWidth) return { width: `calc(100% - ${labelWidth}px)` };
  }, [ labelWidth ]);
  return (
    <div className={classes} style={style}>
      <div className="body-right-row">
        {
          !!title && (
            <div className="body-right-row-title">
              <span>{title}</span>
              {
                !!tooltipText && (
                  <ProTooltip title={tooltipText}>
                    <span className="body-right-row-title-icon">{tooltipIcon}</span>
                  </ProTooltip>
                )
              }
            </div>
          )
        }
        {
          options?.map((item, rowKey) => {
            const {
              label, value, valueType, enumName, copy,
              style: itemStyle, className: itemClassName, tooltipText: itemTooltipText, tooltipIcon: itemTooltipIcon,
            } = item;
            const itemClasses = classNames('body-right-row-item', itemClassName);
            const itemTextClass = classNames('body-right-row-item-text', {
              [`text-${valueType}`]: !!valueType,
            });
            const isString = typeof value === 'string';
            return (
              <div className={itemClasses} style={itemStyle} key={rowKey}>
                <div className="body-right-row-item-label" style={labelStyle}>
                  <span>{label}</span>
                  {
                    !!itemTooltipText && (
                      <ProTooltip title={itemTooltipText}>
                        <span className="body-right-row-item-label-icon">{itemTooltipIcon || <InfoCircleOutlined />}</span>
                      </ProTooltip>
                    )
                  }
                  <span>：</span>
                </div>
                <div className={itemTextClass} style={textStyle} title={isString ? value : undefined}>
                  <div className="yb-line-ellipsis">
                    {
                    copy && isString ? (
                      <CopyText text={value} showTooltips={false} />
                    ) : (
                      enumName ? renderEnumName(value as string, enumData?.[enumName]?.items ?? []) : filterEmptyValue(value)
                    )
                  }
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

RowItem.displayName = ScanPageRightItemEnum.RightRowItem;

RowItem.defaultProps = {
  tooltipIcon: <InfoCircleOutlined />,
};

export default RowItem;